<template>
    <div>
        <div v-if="success">
            <strong>Vielen Dank für deine Bewerbung</strong>
            <div>Wir freuen uns sehr über dein Interesse an unserer neuen Aktion.<br/>
Nach Ablauf der Bewerbungsfrist informieren wir dich gerne per E-Mail darüber, wenn es mit einem Platz im Aktionsteam geklappt hat.<br/>
Wir drücken dir die Daumen!<br/><br/>
Viele Grüße<br/>
dein brands you love-Team</div>
        </div>
	    <div v-if="!success">
	        <question-list :questions="application.questionnaire.questionList" v-if="elementsLoaded" ref="questionList"></question-list>
	        <div id="errorbox" class="errorBox" v-if="hasError"><strong>Bitte korrigiere die markierten Fragen</strong></div>
	        <button class="btn btn-white teaserButton width100" v-on:click="saveApplication">BEWERBUNG ABSENDEN</button>
	    </div>
    </div>
</template>

<script>
    import QuestionList from './QuestionList.vue'

	export default {
		name: 'application',
		props: {
			application: Object
        },
        data: function() {
        	return {
        		elementsLoaded: false,
        		success : false,
        		hasError: false,
        		isSaving: false
        	}
        },
        methods: {
        	validate() {
        		return this.$refs.questionList.onValidate();
        	},
        	saveApplicationSuccess() {
        		this.success = true;
        	},
        	saveApplication() {
        		if(this.isSaving) {
        			return;
        		}
        		this.isSaving = true;
        		//validate
                let hasErrors = false;
                hasErrors = this.validate();
                
                this.hasError = hasErrors;
                
                if (hasErrors) {
                    console.log('There are errors');
                    jQuery("#errorbox").show();
                    this.isSaving = false;
                    return;
                }
                
            	var answers = [];
            	this.application.questionnaire.questionList.forEach(function(item) {
            		if(item.propertyInfo.type.kind == 'MATRIX') {
            			var values = [];
            			for(var key in item.answer.value) {
            			    var value = item.answer.value[key];
            			    if(value) {
            			    	values.push(value);
            			    }
            			}
            			var answer = {};
            			answer.questionId = item.answer.questionId;
            			answer.type = item.answer.type;
            			answer.value = values;
            			answer.visible = item.answer.visible;
            			answers.push(answer);
            		}else {
            			answers.push(item.answer);
            		}
            	});
            	var application = {};
            	application.answers = answers;
            	application.projectId = this.application.projectId;
            	jQuery.ajax ({
                    url: '/saveApplication',
                    type: 'POST',
                    dataType: "json",
                    data: JSON.stringify(application),
                    contentType: "application/json; charset=utf-8",
                    success: this.saveApplicationSuccess,
                    error: function() {console.log("could not save application");}
                });
            	this.isSaving = false;
            },
            onElementsLoaded: function() {
                this.$nextTick(function() {
                    this.elementsLoaded = true;
                });
            }
        },
        components: { QuestionList }
	}
</script>


// WEBPACK FOOTER //
// Application.vue?4abbca6a